import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from 'axios';
import { userObj } from "../../../../helper/protectedRoutes";
import axios from "axios";

const initialState = {
    data: null,
    downloading:null,
    status:null,
}

const token = userObj?.token
const BASE_URL = 'https://redspeedapi.redstarplc.com'


export const exportWoocommercePlugin = createAsyncThunk(
    'exportWoocommercePlugin',
    async (r, {rejectWithValue}) => {
        
        try{
            var _axios = axios.create({ baseURL: BASE_URL });
            const response = await _axios.get(`/Resources/WoocommercePlugin_Redspeed.zip`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

export const exportMagentoPlugin = createAsyncThunk(
    'exportMagentoPlugin',
    async ({rejectWithValue}) => {
        
        try{
            var _axios = axios.create({ baseURL: BASE_URL });
            const response = await _axios.get(`/Resources/MagentoPlugin_Redspeed.zip`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response
        } catch (err) {
            console.log(err.response)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


export default exportWoocommercePlugin.reducer;